import {
  mergeListOfPosts,
  modifyPostComments,
  modifyPostCommentCount,
  replaceUpdatePost,
  updatePostLike,
  modifyPostBookmarkStatus,
  modifyPostOnSubscribedToPerformer,
} from '../../components/helper/Utils'

import {
  SET_OTHER_USER_SINGLE_POST,
  FETCH_SINGLE_USER_PROFILE_START,
  FETCH_SINGLE_USER_PROFILE_SUCCESS,
  FETCH_SINGLE_USER_PROFILE_FAILURE,
  FETCH_SINGLE_USER_POSTS_START,
  FETCH_SINGLE_USER_POSTS_SUCCESS,
  FETCH_SINGLE_USER_POSTS_FAILURE,
  SEARCH_USER_POST_START,
  SEARCH_USER_POST_SUCCESS,
  SEARCH_USER_POST_FAILURE,
  UPDATE_OTHERS_USER_POST_LIKE,
  UPDATE_OTHER_USER_POST_COMMENTS_COUNT,
  UPDATE_OTHER_USER_POST_COMMENTS,
  UPDATE_FOLLOW_STATUS,
  UPDATE_OTHER_USER_POST_BOOKMARK_STATUS,
  FETCH_SINGLE_USER_PUBLIC_PROFILE_START,
  FETCH_SINGLE_USER_PUBLIC_POSTS_START,
  FETCH_SINGLE_USER_PROFILE_RESET,
  SUBSCRIBE_TO_PLAN_SUCCESS,
} from '../actions/ActionConstant'

const initialState = {
  userDetails: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  userPosts: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  searchPosts: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
}

const OtherUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SINGLE_USER_PROFILE_START:
    case FETCH_SINGLE_USER_PUBLIC_PROFILE_START:
      return {
        ...state,
        userDetails: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: 'Loading... Please wait.',
          buttonDisable: true,
        },
      }
    case FETCH_SINGLE_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userDetails: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      }
    case FETCH_SINGLE_USER_PROFILE_FAILURE:
      return {
        ...state,
        userDetails: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      }
    case FETCH_SINGLE_USER_PROFILE_RESET:
      return {
        ...state,
        userDetails: {
          data: {},
          loading: true,
          error: null,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      }
    case SET_OTHER_USER_SINGLE_POST:
      return {
        ...state,
        userPosts: {
          ...state.userPosts,
          data: {
            posts: replaceUpdatePost(
              state.userPosts.data?.posts,
              action.data.post
            ),
          }
        }
      };
    case FETCH_SINGLE_USER_POSTS_START:
    case FETCH_SINGLE_USER_PUBLIC_POSTS_START:
      return {
        ...state,
        userPosts: {
          data: !action.data.skip || action.data.skip === 0 ? initialState.userPosts.data : state.userPosts.data,
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: 'Loading... Please wait.',
          buttonDisable: true,
        },
      }
    case FETCH_SINGLE_USER_POSTS_SUCCESS:
      return {
        ...state,
        userPosts: {
          data: {
            ...action.data,
            posts: mergeListOfPosts(
              state.userPosts.data.posts || [],
              action.data && action.data.posts ? action.data.posts : []
            ),
          },
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      }
    case FETCH_SINGLE_USER_POSTS_FAILURE:
      return {
        ...state,
        userPosts: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      }
    case SEARCH_USER_POST_START:
      return {
        ...state,
        searchPosts: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: 'Loading... Please wait.',
          buttonDisable: true,
        },
      }
    case SEARCH_USER_POST_SUCCESS:
      return {
        ...state,
        searchPosts: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      }
    case SEARCH_USER_POST_FAILURE:
      return {
        ...state,
        searchPosts: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      }
    case UPDATE_OTHERS_USER_POST_LIKE:
      return {
        ...state,
        userPosts: {
          ...state.userPosts,
          data: {
            ...state.userPosts.data,
            posts: updatePostLike(state.userPosts?.data?.posts, action.data),
          },
        },
      }
    case UPDATE_OTHER_USER_POST_COMMENTS_COUNT:
      return {
        ...state,
        userPosts: {
          ...state.userPosts,
          data: {
            ...state.userPosts.data,
            posts: modifyPostCommentCount(state.userPosts?.data?.posts, action.data),
          },
        },
      }
    case UPDATE_OTHER_USER_POST_COMMENTS:
      return {
        ...state,
        userPosts: {
          ...state.userPosts,
          data: {
            ...state.userPosts.data,
            posts: modifyPostComments(state.userPosts.data?.posts, action.data),
          },
        },
      }

    case UPDATE_FOLLOW_STATUS:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          data: {
            ...state.userDetails.data,
            is_following_user: action.data,
          },
        },
      }
    case UPDATE_OTHER_USER_POST_BOOKMARK_STATUS:
      return {
        ...state,
        userPosts: {
          ...state.userPosts,
          data: {
            ...state.userPosts.data,
            posts: modifyPostBookmarkStatus(state.userPosts?.data?.posts, action.data),
          },
        },
      };
    case SUBSCRIBE_TO_PLAN_SUCCESS:
      return {
        ...state,
        userPosts: {
          ...state.userPosts,
          data: {
            ...state.userPosts.data,
            posts: modifyPostOnSubscribedToPerformer(
              state.userPosts.data?.posts || [],
              action.data
            ),
          },
        },
      }

    default:
      return state
  }
}

export default OtherUserReducer
